import { commentsData } from '@/mocks/homeData';

const commentColors = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500'];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{commentsData.title}</h2>
          <p className="text-sm text-foreground-500">{commentsData.subtitle}</p>
        </div>
        <div className="space-y-4">
          {commentsData.items.map((item, idx) => (
            <div key={idx} className="bg-background-100 border border-background-200 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <span className={`w-10 h-10 rounded-full ${commentColors[idx]} flex items-center justify-center text-white text-sm font-bold shrink-0`}>{item.avatar}</span>
                <div>
                  <span className="text-sm font-bold text-foreground-800 block">{item.nickname}</span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line mr-1"></i>{item.likes.toLocaleString()}
                </span>
                <span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line mr-1"></i>回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}